import React from 'react';
import DashboardLayout from './components/DashboardLayout';
import DocsLayout from './components/docs/DocsLayout';
import DocsRouter from './components/docs/DocsRouter';
import SentryDocsLayout from './components/docs/SentryDocsLayout';
import SentryDocsRouter from './components/docs/SentryDocsRouter';
// import TVLPage from './components/TVLPage';
import LandingPage from './components/landing/LandingPage';
import ExplorePageV2 from './pages/ExplorePageV2';
import TradePage from './pages/TradePage';
import BridgePage from './pages/BridgePage';
import TydroPage from './pages/TydroPage';
import PayPage from './pages/PayPage';
import ProfilePage from './pages/ProfilePage';
import TokenLocksPage from './pages/TokenLocksPage';
import TokenDetailPage from './pages/TokenDetailPage';
import CreateTokenPage from './pages/CreateTokenPage';
import RndTokenPage from './pages/RndTokenPage';
import WidgetLaunchPage from './pages/WidgetLaunchPage';
import HowToPage from './pages/HowToPage';
import WidgetSample from './pages/WidgetSample';
import WhitepaperPage from './pages/WhitepaperPage';
import MavrkTokenPage from './pages/MavrkTokenPage';
import MonadPage from './pages/MonadPage';
import MonadTokenDetailPage from './pages/MonadTokenDetailPage';
import EthPage from './pages/EthPage';
import EthTokenDetailPage from './pages/EthTokenDetailPage';
import SolanaPage from './pages/SolanaPage';
import SolanaPageMinimal from './pages/SolanaPageMinimal';
import UnifiedAppPage from './pages/UnifiedAppPage';
import SentryDashboard from './pages/SentryDashboard';
import SentryTokensPage from './pages/SentryTokensPage';
import UnifiedLiquidityPage from './pages/UnifiedLiquidityPage';
import MonadDomainRedirect from './components/monad/MonadDomainRedirect';
import SentryDomainRedirect from './components/sentry/SentryDomainRedirect';
import SentryRootRoute from './components/sentry/SentryRootRoute';
import SentryDocsRoute from './components/sentry/SentryDocsRoute';
import MonadMetaTags from './components/monad/MonadMetaTags';
import SentryMetaTags from './components/sentry/SentryMetaTags';
import InvestorMetaTags from './components/investor/InvestorMetaTags';
// WLFI (World Liberty Financial) Pages
import WLFILayout from './pages/wlfi/WLFILayout';
import WLFIExplorePage from './pages/wlfi/WLFIExplorePage';
import WLFITradePage from './pages/wlfi/WLFITradePage';
import WLFICreateTokenPage from './pages/wlfi/WLFICreateTokenPage';
import WLFIPortfolioPage from './pages/wlfi/WLFIPortfolioPage';
import ETHLayout from './pages/eth/ETHLayout';
import ETHExplorePage from './pages/eth/ETHExplorePage';
import ETHTradePage from './pages/eth/ETHTradePage';
import ETHCreateTokenPage from './pages/eth/ETHCreateTokenPage';
import ETHPortfolioPage from './pages/eth/ETHPortfolioPage';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import '@fontsource/press-start-2p';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './style.css';
import { ChainProvider } from './components/ChainContext';
import { UserProvider } from './components/UserContext';
import { ThemeProvider } from './components/ThemeContext';
import PWALayout from './layouts/PWALayout';
import PWAEntryFlow from './pages/pwa/PWAEntryFlow';
import LandingPagePWA from './pages/pwa/LandingPagePWA';
import CreateTokenPWA from './pages/pwa/CreateTokenPWA';
import ExplorePWA from './pages/pwa/ExplorePWA';
import SwapPWA from './pages/pwa/SwapPWA';
import TokenDetailsPagePWA from './pages/pwa/TokenDetailsPagePWA';
import LocksPWA from './pages/pwa/LocksPWA';
import ProfilePWA from './pages/pwa/ProfilePWA';
import SentryPWALayout from './layouts/SentryPWALayout';
import SentryAgentLayout from './layouts/SentryAgentLayout';
import SentryPWAEntryFlow from './pages/sentry-pwa/SentryPWAEntryFlow';
import SentryAgentWalletPWA from './pages/sentry-pwa/SentryAgentWalletPWA';
import SentryAgentStrategyPWA from './pages/sentry-pwa/SentryAgentStrategyPWA';
import SentryTokensPWA from './pages/sentry-pwa/SentryTokensPWA';
import SentryStatsPWA from './pages/sentry-pwa/SentryStatsPWA';
import SentryCreatePWA from './pages/sentry-pwa/SentryCreatePWA';
import SentrySwapPWA from './pages/sentry-pwa/SentrySwapPWA';
import SentryWalletPWA from './pages/sentry-pwa/SentryWalletPWA';
import SentryDocsPWA from './pages/sentry-pwa/SentryDocsPWA';
import SentryTelegramHandoff from './pages/sentry-pwa/SentryTelegramHandoff';
import SentryDesktopLayout from './layouts/SentryDesktopLayout';
import SentryDesktopEntryFlow from './pages/sentry-desktop/SentryDesktopEntryFlow';
import InvestorPWALayout from './layouts/InvestorPWALayout';
import InvestorPWAEntryFlow from './pages/investor-pwa/InvestorPWAEntryFlow';
import InvestorDashboardPWA from './pages/investor-pwa/InvestorDashboardPWA';
import InvestorFeedbackPWA from './pages/investor-pwa/InvestorFeedbackPWA';
import InvestorAnnouncementsPWA from './pages/investor-pwa/InvestorAnnouncementsPWA';
import InvestorAdminLayout from './layouts/InvestorAdminLayout';
import InvestorAdminEntryFlow from './pages/investor-pwa/InvestorAdminEntryFlow';
import InvestorAdminDashboardPWA from './pages/investor-pwa/InvestorAdminDashboardPWA';
import InvestorAdminAnnouncementsPWA from './pages/investor-pwa/InvestorAdminAnnouncementsPWA';
import { Analytics } from '@vercel/analytics/react';
import { NotificationSystem } from './components/shared/NotificationSystem';

// Import docs pages - these are used in DocsRouter

// Test commit to verify Vercel deployment is working with new config
const NotificationSystemMount: React.FC = () => {
  const location = useLocation();
  const isPwaRoute =
    location.pathname.startsWith('/sentry-pwa') ||
    location.pathname.startsWith('/sentry-desktop') ||
    location.pathname.startsWith('/pwa');

  return (
    <NotificationSystem
      apiUrl={(import.meta.env as any).VITE_SENTRY_BOT_API_URL || ''}
      pollInterval={10000}
      maxNotifications={5}
      autoDismissTime={5000}
      placement={isPwaRoute ? 'pwaHeader' : 'default'}
      enablePwaSwaps={isPwaRoute}
    />
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <ChainProvider>
        <UserProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <MonadMetaTags />
            <SentryMetaTags />
            <InvestorMetaTags />
            <MonadDomainRedirect>
              <SentryDomainRedirect>
                <Routes>
                  {/* Root route - shows SentryLandingPage on sentry.trading, otherwise LandingPage */}
                  <Route path="/" element={<SentryRootRoute />} />

                {/* Unified App Page for mavrk.xyz/app - Multi-chain token dashboard */}
                <Route path="/app" element={<UnifiedAppPage />} />
                
                {/* Unified Liquidity Page for mavrk.xyz/pools - V3 pool creation and management */}
                <Route path="/pools" element={<UnifiedLiquidityPage />} />
                
                {/* Redirect legacy /app/* routes to new routes (except /app which is now UnifiedAppPage) */}
                <Route path="/app/explore" element={<Navigate to="/explore" replace />} />
                <Route path="/app/bridge" element={<Navigate to="/bridge" replace />} />
                <Route path="/app/tydro" element={<Navigate to="/tydro" replace />} />
                <Route path="/app/pay" element={<Navigate to="/pay" replace />} />
                <Route path="/app/locks" element={<Navigate to="/locks" replace />} />
                <Route path="/app/profile" element={<Navigate to="/profile" replace />} />
                <Route path="/app/token/:tokenAddress" element={<Navigate to="/token/:tokenAddress" replace />} />

                {/* Dashboard routes with layout */}
                <Route element={<DashboardLayout />}>
                  <Route path="/widget/sample" element={<WidgetSample />} />
                  <Route path="/create" element={<CreateTokenPage />} />
                  <Route path="/RND" element={<RndTokenPage />} />
                  <Route path="/explore" element={<ExplorePageV2 />} />
                  <Route path="/trade" element={<TradePage />} />
                  <Route path="/bridge" element={<BridgePage />} />
                  <Route path="/tydro" element={<TydroPage />} />
                  <Route path="/pay" element={<PayPage />} />
                  <Route path="/token/:tokenAddress" element={<TokenDetailPage />} />
                  <Route path="/locks" element={<TokenLocksPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/MAVRK-token" element={<MavrkTokenPage />} />
                </Route>

                {/* Monad routes without DashboardLayout (custom nav bar) */}
                <Route path="/monad" element={<MonadPage />} />
                <Route path="/monad/token/:tokenAddress" element={<MonadTokenDetailPage />} />

                {/* Ethereum routes without DashboardLayout (custom nav bar) */}
                <Route path="/eth" element={<EthPage />} />
                <Route path="/eth/token/:tokenAddress" element={<EthTokenDetailPage />} />

                {/* Solana routes */}
                <Route path="/solana" element={<SolanaPageMinimal />} />
                
                {/* Sentry Dashboard - Analytics page (no wallet connect needed) */}
                <Route path="/Sentry" element={<SentryDashboard />} />
                
                {/* Lowercase /sentry route - redirects to /Sentry */}
                <Route path="/sentry" element={<Navigate to="/Sentry" replace />} />
                
                {/* Sentry domain routes - /dashboard and /docs for sentry.trading */}
                <Route path="/dashboard" element={<SentryDashboard />} />
                <Route path="/tokens" element={<SentryTokensPage />} />
                <Route path="/docs" element={<SentryDocsRoute />} />
                <Route path="/docs/*" element={<SentryDocsRoute />} />

                {/* Sentry Desktop PWA Routes */}
                <Route path="/sentry-desktop" element={<SentryDesktopEntryFlow />} />
                <Route element={<SentryDesktopLayout />}>
                  <Route path="/sentry-desktop/dashboard" element={<SentryDashboard />} />
                  <Route
                    path="/sentry-desktop/tokens"
                    element={
                      <SentryTokensPWA
                        basePath="/sentry-desktop"
                        tokenClickMode="chart"
                        showPageTitle={false}
                        featuredLayout="split"
                      />
                    }
                  />
                  <Route path="/sentry-desktop/create" element={<SentryCreatePWA authLabel="Sentry Account" />} />
                  <Route path="/sentry-desktop/swap" element={<SentrySwapPWA />} />
                  <Route path="/sentry-desktop/wallet" element={<SentryWalletPWA authLabel="Sentry Account" basePath="/sentry-desktop" />} />
                  <Route path="/sentry-desktop/docs" element={<SentryDocsRoute />} />
                  <Route path="/sentry-desktop/docs/*" element={<SentryDocsRoute />} />
                </Route>

                {/* WLFI (World Liberty Financial) routes with custom layout */}
                <Route path="/app/wlfi" element={<WLFILayout />}>
                  <Route index element={<Navigate to="/app/wlfi/explore" replace />} />
                  <Route path="explore" element={<WLFIExplorePage />} />
                  <Route path="trade" element={<WLFITradePage />} />
                  <Route path="create" element={<WLFICreateTokenPage />} />
                  <Route path="portfolio" element={<WLFIPortfolioPage />} />
                </Route>

                {/* ETH routes with custom layout */}
                <Route path="/app/eth" element={<ETHLayout />}>
                  <Route index element={<Navigate to="/app/eth/explore" replace />} />
                  <Route path="explore" element={<ETHExplorePage />} />
                  <Route path="trade" element={<ETHTradePage />} />
                  <Route path="create" element={<ETHCreateTokenPage />} />
                  <Route path="portfolio" element={<ETHPortfolioPage />} />
                </Route>

                {/* Docs route - shows Sentry docs on sentry.trading, main docs on other domains */}
                <Route path="/docs" element={<SentryDocsRoute />} />
                <Route path="/docs/*" element={<SentryDocsRoute />} />

                {/* Sentry Bot Documentation */}
                <Route path="/sentry/docs" element={<SentryDocsLayout><SentryDocsRouter /></SentryDocsLayout>} />
                <Route path="/sentry/docs/*" element={<SentryDocsLayout><SentryDocsRouter /></SentryDocsLayout>} />

                {/* Hidden How-To page (not in navigation) */}
                <Route path="/how-to" element={<HowToPage />} />

                {/* Whitepaper page (minimal, no navigation) */}
                <Route path="/whitepaper" element={<WhitepaperPage />} />

                {/* Widget route (no dashboard layout for clean embed) */}
                <Route path="/widget/launch" element={<WidgetLaunchPage />} />

                {/* PWA Routes - Added after regular routes to ensure separation */}
                <Route path="/pwa" element={<PWAEntryFlow />} />
                <Route element={<PWALayout />}>
                  <Route path="/pwa/create" element={<CreateTokenPWA />} />
                  <Route path="/pwa/explore" element={<ExplorePWA />} />
                  <Route path="/pwa/swap" element={<SwapPWA />} />
                  <Route path="/pwa/token/:tokenAddress" element={<TokenDetailsPagePWA />} />
                  <Route path="/pwa/locks" element={<LocksPWA />} />
                  <Route path="/pwa/profile" element={<ProfilePWA />} />
                </Route>

                {/* Sentry PWA Routes - isolated from Mavrk PWA */}
                <Route path="/sentry-pwa/auth" element={<SentryTelegramHandoff />} />
                <Route path="/sentry-pwa" element={<SentryPWAEntryFlow />} />
                <Route element={<SentryPWALayout />}>
                  <Route path="/sentry-pwa/tokens" element={<SentryTokensPWA />} />
                  <Route path="/sentry-pwa/stats" element={<SentryStatsPWA />} />
                  <Route path="/sentry-pwa/create" element={<SentryCreatePWA />} />
                  <Route path="/sentry-pwa/swap" element={<SentrySwapPWA />} />
                  <Route path="/sentry-pwa/wallet" element={<SentryWalletPWA />} />
                  <Route path="/sentry-pwa/docs" element={<SentryDocsPWA />} />
                </Route>

                {/* Sentry Agent PWA Routes (wallet-only) */}
                <Route element={<SentryAgentLayout />}>
                  <Route path="/sentry-agent/wallet" element={<SentryAgentWalletPWA />} />
                  <Route path="/sentry-agent/strategy" element={<SentryAgentStrategyPWA />} />
                </Route>

                {/* Investor PWA Routes - isolated from other PWAs */}
                <Route path="/investor-pwa" element={<InvestorPWAEntryFlow />} />
                <Route element={<InvestorPWALayout />}>
                  <Route path="/investor-pwa/dashboard" element={<InvestorDashboardPWA />} />
                  <Route path="/investor-pwa/feedback" element={<InvestorFeedbackPWA />} />
                  <Route path="/investor-pwa/announcements" element={<InvestorAnnouncementsPWA />} />
                </Route>

                {/* Investor Admin Routes */}
                <Route path="/investor-pwa/admin" element={<InvestorAdminEntryFlow />} />
                <Route element={<InvestorAdminLayout />}>
                  <Route path="/investor-pwa/admin/dashboard" element={<InvestorAdminDashboardPWA />} />
                  <Route path="/investor-pwa/admin/announcements" element={<InvestorAdminAnnouncementsPWA />} />
                </Route>

                {/* <Route path="/tvl" element={<TVLPage />} /> */}
                {/* <Route path="/Krakenpitch" element={<PitchDeckPage />} /> */}
              </Routes>
              </SentryDomainRedirect>
            </MonadDomainRedirect>
            <NotificationSystemMount />
          </BrowserRouter>
          <Analytics />
        </UserProvider>
      </ChainProvider>
    </ThemeProvider>
  );
};

export default App;